(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-free-gift"] && !Shopify.designMode) return;
  try {
    class WDNCartGifts extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest('[data-cart-free-gift-container]');
      this.handleCartUpdate = this.onCartUpdate.bind(this);
    }

    connectedCallback() {
      document.addEventListener('cartlayout:updated', this.handleCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cartlayout:updated', this.handleCartUpdate);
    }

    async onCartUpdate(e) {
      const text = e.detail.cartResponseText;
      if (!text) {
        return;
      }
      const data = JSON.parse(text);
      const sections = data.sections || data;
      const cartDrawerSection = sections['cart-drawer'];
      const html = new DOMParser().parseFromString(cartDrawerSection, 'text/html');
      const container = html.querySelector('[data-cart-free-gift-container]');
      if (!container) {
        return;
      }
      this.container.replaceWith(container);
      this.container = container;
    }
  }

  if (!customElements.get('wdn-cart-gifts')) {
    customElements.define('wdn-cart-gifts', WDNCartGifts);
  }

  class WDNCartGiftItem extends HTMLElement {
    constructor() {
      super();

      this.WDNCart = document.querySelector('wdn-cart');

      this.submitBtn = this.querySelector('button[data-name="gift_update"]');
      this.lineId = this.getAttribute('data-line-id');
      this.giftStatus = this.getAttribute('data-gift-status');
      this.handleAdd = this.onGiftClick.bind(this);
    }

    connectedCallback() {
      this.submitBtn?.addEventListener('click', this.handleAdd);
      if (this.giftStatus == 'invalid') {
        this.removeFromCart();
      }
    }

    disconnectedCallback() {
      this.submitBtn?.removeEventListener('click', this.handleAdd);
    }

    onGiftClick() {
      if (this.giftStatus !== 'unlocked') {
        return;
      }
      this.addToCart();
    }

    async addToCart() {
      await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: this.lineId,
              quantity: 1,
              properties: {
                _isFreeGift: 'yes',
              },
            },
          ],
        }),
      });

      this.WDNCart?.reloadCart();
    }

    async removeFromCart() {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.lineId,
          quantity: 0,
        }),
      });

      this.WDNCart?.reloadCart();
    }
  }

  if (!customElements.get('wdn-gift-item')) {
    customElements.define('wdn-gift-item', WDNCartGiftItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-description-modal"] && !Shopify.designMode) return;
  try {
    class ProductCardDescription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.modal = this.querySelector('wdn-modal');
      if (!this.modal) return;

      this.onModalOpened = this.handleModalOpened.bind(this);
      document.body.addEventListener('overlay:opened', this.onModalOpened);
    }

    disconnectedCallback() {
      document.body.removeEventListener('overlay:opened', this.onModalOpened);
      if (this.modal?.isActive) this.modal.close();
    }

    handleModalOpened(event) {
      if (event.detail !== this.modal) return;
      this.load();
    }

    async load() {
      if (this.loaded || this.loading) return;

      const output = this.modal?.querySelector('[data-product-description-output]');
      if (!output) return;

      this.loading = true;
      this.loaded = false;
      output.setAttribute('aria-busy', 'true');
      output.innerHTML = `
        <div class="product-card-description__loading" role="status">
          <span class="product-card-description__spinner" aria-hidden="true"></span>
        </div>
      `;

      try {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', 'product-description-helper');
        const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        output.innerHTML = await response.text();
        this.loaded = true;
      } catch (error) {
        output.innerHTML = `
          <div class="product-card-description__error" role="alert">
            <p>${this.escapeHtml(this.dataset.loadError)}</p>
          </div>
        `;
      } finally {
        this.loading = false;
        output.removeAttribute('aria-busy');
      }
    }

    escapeHtml(value) {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    }
  }

  if (!customElements.get('product-card-description')) {
    customElements.define('product-card-description', ProductCardDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["replace_non_responsive_tables"] && !Shopify.designMode) return;
  try {
    class ResponsiveTable extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.responsive-table');

      if (!this.scroller) return;

      this.update = this.update.bind(this);

      this.scroller.addEventListener('scroll', this.update, {
        passive: true,
      });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.scroller);

      this.update();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    update() {
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;

      const hasMore = maxScroll > 1 && this.scroller.scrollLeft < maxScroll - 1;

      this.classList.toggle('has-more', hasMore);
    }
  }

  if (!customElements.get('responsive-table-component')) {
    customElements.define('responsive-table-component', ResponsiveTable);
  }
  } catch(e) { console.error(e); }
})();

})();
